import React, { useState, useEffect } from 'react';
import { Drawer, Button, Skeleton, Row, Col } from 'antd';
import { connect } from "react-redux";
import { CloseOutlined, EditOutlined } from "@ant-design/icons"
import { Link } from 'react-router-dom';
/* custom component */
import { ViewBox, ViewLabel, ViewValue } from "../../../component/Xcomponent"

/* action */
import { getSampleContainerTestMapDetail, getSampleContainerTestMapDetailReset } from "../../../action/getSampleContainerTestMapDetailAction"
import { dateFormat } from '../../../utils';

const SampleContainerTestMapView = props => {
    /* variable */
    const { getSampleContainerTestMapDetail, getSampleContainerTestMapDetailReset, getSampleContainerTestMapDetailState } = props

    /* callbacks */
    useEffect(() => {
        if (props.visible === false) {
            getSampleContainerTestMapDetailReset()
        }
    }, [props.visible])

    useEffect(() => {
        if (props.id && props.visible) {
            getSampleContainerTestMapDetail({
                id: props.id
            })
        }
    }, [props.id, props.visible])

    return (
        <Drawer
            title={`Simple Container Test Map Master View`}
            placement="right"
            closeIcon={<><Link to={`/sample-container-test-map-master/edit/${props.id}`}><Button size="small" shape="circle" icon={<EditOutlined />} /></Link> <Button size="small" shape="circle" icon={<CloseOutlined />} /></>}
            onClose={props.onClose}
            visible={props.visible}
            width={800}
        >
            {getSampleContainerTestMapDetailState.apiState === "loading" &&
                <Skeleton active />}

            {getSampleContainerTestMapDetailState.apiState === "error" &&
                <p>{getSampleContainerTestMapDetailState.message}</p>
            }

            {getSampleContainerTestMapDetailState.apiState === "success" &&
                <>
                    <Row gutter={20} >
                        <Col span="12">
                            <ViewBox>
                                <ViewLabel>Sample</ViewLabel>
                                <ViewValue>{getSampleContainerTestMapDetailState.data.sample?.sample_type}</ViewValue>
                            </ViewBox>
                        </Col>
                        <Col span="12">
                            <ViewBox>
                                <ViewLabel>Test Group</ViewLabel>
                                <ViewValue>{getSampleContainerTestMapDetailState.data.test_group.length > 0 &&
                                    getSampleContainerTestMapDetailState.data.test_group.map(obj => obj.value).join(", ")}</ViewValue>
                            </ViewBox>
                        </Col>
                        <Col span="12">
                            <ViewBox>
                                <ViewLabel>Container</ViewLabel>
                                <ViewValue>{getSampleContainerTestMapDetailState.data.container?.display_container_name}</ViewValue>
                            </ViewBox>
                        </Col>
                        <Col span="12">
                            <ViewBox>
                                <ViewLabel>CreatedAt</ViewLabel>
                                <ViewValue>{dateFormat(getSampleContainerTestMapDetailState.data.createdAt)}</ViewValue>
                            </ViewBox>
                        </Col>
                        <Col span="12">
                            <ViewBox>
                                <ViewLabel>UpdatedAt</ViewLabel>
                                <ViewValue>{dateFormat(getSampleContainerTestMapDetailState.data.updatedAt)}</ViewValue>
                            </ViewBox>
                        </Col>

                    </Row>
                </>
            }
        </Drawer >
    )
}

const mapStateToProps = (state) => ({
    getSampleContainerTestMapDetailState: state.getSampleContainerTestMapDetail
});

const mapDispatchToProps = (dispatch) => ({
    getSampleContainerTestMapDetail: (params) => dispatch(getSampleContainerTestMapDetail(params)),
    getSampleContainerTestMapDetailReset: () => dispatch(getSampleContainerTestMapDetailReset()),

});

export default connect(mapStateToProps, mapDispatchToProps)(SampleContainerTestMapView);